import { createSelector } from 'reselect';

import { PICTURE_GALLERY_KEY } from './constants';

export const getPictureGalleryParameters = createSelector(
    state => state[PICTURE_GALLERY_KEY],
    gallery => gallery
);
